function accordion() {
    if ( $('.accordion-list').length ) {
        $('.accordion-item__title').click(function(e) {
            e.preventDefault();
            let $this = $(this),
                $accordionCont = $this.parent(),
                $accordionBody = $this.siblings('.accordion-item__body');

            $accordionCont.toggleClass('accordion--open');
            $accordionBody.slideToggle(500);
        });
    }
}